var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3748 9.39755C21.9851 10.3109 21.9851 11.5825 21.9851 14.1255C21.9851 16.6686 21.9851 17.9401 21.3748 18.8535C21.1106 19.249 20.7711 19.5885 20.3757 19.8527C19.5777 20.3858 18.5065 20.4532 16.553 20.4618V20.463L15.5521 22.4649C15.2184 23.1321 14.2662 23.1321 13.9325 22.4649L12.9316 20.463V20.4618C10.9781 20.4532 9.9069 20.3858 9.10897 19.8527C8.71355 19.5885 8.37404 19.249 8.10983 18.8535C7.49951 17.9401 7.49951 16.6686 7.49951 14.1255C7.49951 11.5825 7.49951 10.3109 8.10983 9.39755C8.37404 9.00212 8.71355 8.66261 9.10897 8.3984C10.0224 7.78809 11.2939 7.78809 13.837 7.78809H15.6477C18.1907 7.78809 19.4623 7.78809 20.3757 8.3984C20.7711 8.66261 21.1106 9.00212 21.3748 9.39755Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0263 12.3149L17.4584 12.3149",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0263 15.9363H14.7423",
    stroke: "#9E9E9E",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerOff);
export default __webpack_public_path__ + "static/media/answer-off.71fdc9c7dec18ca98ae8d121b62bb719.svg";
export { ForwardRef as ReactComponent };